import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import MethylationNitricOxideCombined from "./index";

const MethylationNitricOxideWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={MethylationNitricOxideCombined}
    keyControlsId="methylation-nitric-oxide-key"
    {...props}
  />
);

export default MethylationNitricOxideWithToggleKey;
